import { cn } from '@/shared/lib/cn';
import type { HistoryCell } from './historyRows';
import type { Tone } from './historyText';

export const TONE_CLASS: Record<Tone, string> = {
  green: 'bg-forest-soft text-forest-deep',
  amber: 'bg-amber-tint text-amber-ink',
  red: 'bg-sealwax-tint text-sealwax',
  grey: 'bg-card-alt text-ink',
};

/** Zustand als Pille; ein reiner Text bleibt Text. */
export function HistoryCellView({ cell, className }: { cell: HistoryCell; className?: string }) {
  if (typeof cell === 'string') {
    return (
      <span title={cell} className={cn('min-w-0 truncate text-[13px]', className)}>
        {cell}
      </span>
    );
  }
  return (
    <span
      className={cn(
        'rounded-pill inline-flex h-[22px] items-center justify-self-start whitespace-nowrap px-2.5 text-[11px] font-bold',
        TONE_CLASS[cell.tone],
      )}
    >
      {cell.label}
    </span>
  );
}
